import { useState, useEffect, useCallback } from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  useHistory,
} from "react-router-dom";
import axios from "axios";
import logo from "./images/logo.png";
import "./App.less";
import Stats from "./pages/Stats";
import Assets from "./pages/Assets/Assets";
import { ChainAssets } from "./pages/Assets/AssetsInterfaces";
import { prepareTransferConfigs } from "./pages/Assets/transferConfigAnalyzer";
import { FC } from "react";

interface IProps {
  title: string;
  selectedIndex: number;
  currentIndex: number;
  onClicked: (currentIndex: number) => void;
}

export const HomeButton: FC<IProps> = ({
  title,
  selectedIndex,
  currentIndex,
  onClicked,
}) => {
  let history = useHistory();

  function handleClick() {
    if (selectedIndex === 0) {
      history.push("/analytics");
    } else {
      history.push("/assets");
    }
    onClicked(selectedIndex);
  }

  return (
    <button onClick={handleClick} className="App-header-button">
      <div
        className={
          selectedIndex === currentIndex ? "highlighted-text" : "normal-text"
        }
      >
        {title}
      </div>
      <div
        className={
          selectedIndex === currentIndex ? "selected-icon" : "normal-icon"
        }
      />
    </button>
  );
};

const App = () => {
  const [currentButtonIndex, setCurrentButtonIndex] = useState(0);
  const [assetInfo, setAssetInfo] = useState<{
    chainsNumber: number;
    tokensNumber: number;
    bridgesNumber: number;
    chainAssetsList: ChainAssets[];
  }>({
    chainsNumber: 0,
    tokensNumber: 0,
    bridgesNumber: 0,
    chainAssetsList: [],
  });
  const [fetchingAssetInfo, setFetchingAssetInfo] = useState(true);

  const getData = useCallback(async () => {
    const res = await axios.get(
      `https://cbridge-prod2.celer.app/v1/getTransferConfigsForAll`
    );
    setAssetInfo(prepareTransferConfigs(res.data));
    setFetchingAssetInfo(false);
  }, []);

  useEffect(() => {
    getData();
  }, [getData]);

  useEffect(() => {
    if (window.location.href.includes("/assets")) {
      setCurrentButtonIndex(1);
    } else if (window.location.href.includes("/analytics")) {
      setCurrentButtonIndex(0);
    }
  }, []);

  return (
    <Router>
      <div className="App">
        <header className="App-header">
          <div style={{ width: 54 }}></div>

          <a
            className="App-link"
            href="https://cbridge.celer.network"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={logo} className="App-logo" alt="logo" />
          </a>

          <div style={{ width: 70 }}></div>

          <HomeButton
            title="Analytics"
            selectedIndex={0}
            currentIndex={currentButtonIndex}
            onClicked={setCurrentButtonIndex}
          />

          <div style={{ width: 70 }}></div>

          <HomeButton
            title="Assets"
            selectedIndex={1}
            currentIndex={currentButtonIndex}
            onClicked={setCurrentButtonIndex}
          />
        </header>
        <div className="content">
          <Switch>
            <Route exact path="/">
              <Stats />
            </Route>

            <Route exact path="/analytics">
              <Stats />
            </Route>
            <Route path="/assets">
              <Assets
                isFetching={fetchingAssetInfo}
                chainsNumber={assetInfo.chainsNumber}
                tokensNumber={assetInfo.tokensNumber}
                bridgesNumber={assetInfo.bridgesNumber}
                chainAssetsList={assetInfo.chainAssetsList}
              />
            </Route>
          </Switch>
        </div>
      </div>
    </Router>
  );
};

export default App;
